<template>
    <div class="md-testimionial comments-box">
        <div class="comment-tab">
            <span
                class="tab-item tab-recommend"
                :class="{ active: isRecommend }"
                @click="isRecommend = true"
            >{{ $t('md-testimonial.recommend') }}</span
            >
            <span
                class="tab-item tab-refer"
                :class="{ active: !isRecommend }"
                @click="isRecommend = false"
            >{{ $t('md-testimonial.referAFriend') }}</span
            >
        </div>
        <!-- TODO:  The logic here can be used later  componentId  way to transform  -->
        <div class="recommend-box" v-if="isRecommend">
            <review-add
                @addReview="updateComments"
                :title="reviewAddTitle"
            ></review-add>
            <comment-list
                :testimonialTitle="testimonialTitle"
                commentTheme="online"
                :pageSize="30"
                :comments="testimonials"
            ></comment-list>
        </div>
        <div v-else>
            <refer-friend></refer-friend>
        </div>
    </div>
</template>

<script>
import reviewAdd from './review-add.vue';
import commentList from './comment-list.vue';
import referFriend from './refer-friend.vue';

export default {
    emits: ['updateComments'],
    name: 'comments-box',
    i18next: {
        ns: 'md-testimonial'
    },
    props: {
        testimonials: {
            type: Array
        },
        testimonialTitle: {
            type: String
        },
        reviewAddTitle: {
            type: String
        }
    },
    components: {
        reviewAdd,
        commentList,
        referFriend
    },
    data: function() {
        return {
            isRecommend: true
        };
    },
    methods: {
        updateComments(saveId) {
            this.$emit('updateComments', saveId);
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.md-testimionial.comments-box {
    .comment-tab {
        display: flex;
        margin-bottom: 16px;
        .tab-item {
            width: 131px;
            height: 40px;
            text-align: center;
            font-weight: bold;
            line-height: 40px;
            background-color: #010102;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
        }
        .active {
            @include color-button();
        }
    }
}
</style>
